/**
 * 商品情報用VO
 *
 * @export KYMW1406GoodsInfoModel
 * @class KYMW1406GoodsInfoModel
 */
export class KYMW1406GoodsInfoModel {
  /**
   *  Ｐコード
   */
  public pCode = String('');

  /**
   * 注文コードSEQNO
   */
  public orderNumSeqNo = Number(0);

  /**
   * 優先度
   */
  public priority = Number(0);
}
